import { AppResponse } from "src/models/app-response";
import { endpoints } from "src/utils/api-endpoints";
import axios from 'src/utils/axios';

export async function getPaymentMethodDetails(id: string): Promise<AppResponse<unknown>> {
  const URL = `${endpoints.card.getCardDetails(id)}`;
  try {
    const response = await axios.get(URL);
    return {
      success: true,
      data: response.data.data,
    };
  } catch (error) {
    return { success: false, error: error.message || 'Unknown error' };
  }
}

export async function removePaymentMethod(id: string): Promise<AppResponse<unknown>> {
  const URL = `${endpoints.card.removeCardDetails(id)}`;
  try {
    const response = await axios.delete(URL);
    return {
      success: true,
      data: response.data.data,
    };
  } catch (error) {
    return { success: false, error: error.message || 'Unknown error' };
  }
}
